import { Row } from 'shared/components/other';
import { ServerModels as SM } from 'types/server';

export const convertLogData = (logData: SM.OperationLogEntry[]): Row<SM.OperationLogEntry>[] =>
  logData.map((x, index) => ({
    data: x,
    rowId: `${x.csId}-${index}`,
    children: null,
  }));
